import Vue from 'vue';
import service from './base.service'
import {AxiosPromise} from 'axios';
import {AppResponse} from '@/share/response';
import {
  BabyAlbumModel,
  BabyHomeModel,
  BabyModel,
  MilestoneClearModel,
  TutorialDto,
  TutorialModel,
  MilestoneDto
} from "@/share";

export class BabyService extends Vue {
  private RESOURCE = 'front/babies';

  public milestoneClear(id: number | string, payload: any): AxiosPromise<AppResponse<MilestoneClearModel>> {
    return service.post<AppResponse<MilestoneClearModel>>(`${this.RESOURCE}/${id}/milestone-clear`, payload);
  }

  public list(): AxiosPromise<AppResponse<BabyHomeModel[]>> {
    return service.get<AppResponse<BabyHomeModel[]>>(this.RESOURCE);
  }

  public getAlbums(id: number | string): AxiosPromise<AppResponse<BabyAlbumModel[]>> {
    return service.get<AppResponse<BabyAlbumModel[]>>(`${this.RESOURCE}/${id}/albums`);
  }

  public getTutorials(id: number | string): AxiosPromise<AppResponse<TutorialModel[]>> {
    return service.get<AppResponse<TutorialModel[]>>(`${this.RESOURCE}/${id}/tutorials`);
  }

  public setTutorials(id: number | string, payload: TutorialDto): AxiosPromise<AppResponse<any>> {
    return service.post<AppResponse<any>>(`${this.RESOURCE}/${id}/tutorials`, payload);
  }

  public readMilestone(id: number | string, payload: MilestoneDto): AxiosPromise<AppResponse<any>> {
    return service.post<AppResponse<any>>(`${this.RESOURCE}/${id}/read-milestone`, payload);
  }

  public addNewBaby(payload: any): AxiosPromise<AppResponse<BabyModel>> {
    return service.post<AppResponse<any>>(this.RESOURCE , payload);
  }

  public deleteBaby(id: number | string): AxiosPromise<AppResponse<any>> {
    return service.delete<AppResponse<any>>(`${this.RESOURCE}/${id}`);
  }
}
